import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import RedirectLogin from "./helpers/Redirect_Login";
import PrivateRoute from "./components/PrivateRoute";
import RedirectIfAuthRoute from "./components/RedirectIfAuthRoute";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import { updateUser, useAuthDispatch } from "./context/Auth";
import { useSystem } from "./context/System";
import { PLATFORM_LOGO } from "./constants";
import "./styles/App.scss";

function App() {
  const dispatch = useAuthDispatch();
  const { system } = useSystem();

  const get_current_user = async (token) => {
    //send token to get session from DB
    //user comes back from DB
    //update the user to the passed user object

    updateUser(dispatch, JSON.parse(localStorage.getItem("_token")));

    //otherwise send back error message
  };

  useEffect(() => {
    if (system) {
      document.title = PLATFORM_LOGO[system.system].title;
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = PLATFORM_LOGO[system.system].iconUrl;
      }
    }
  }, [system]);

  useEffect(() => {
    if (localStorage.getItem("_token")) {
      get_current_user(localStorage.getItem("_token"));
    }
  });

  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<RedirectLogin />} />
        <Route path='/' element={<RedirectIfAuthRoute />}>
          <Route path='/login' element={<Login />} />
          <Route path='/forget-password' element={<ForgetPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
        </Route>
        <Route path='/dashboard' element={<PrivateRoute />}>
          <Route path='/dashboard' element={<Dashboard />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
